import { render, staticRenderFns } from "./TargetCampaignHealthContent.vue?vue&type=template&id=274cdd38&scoped=true"
import script from "./TargetCampaignHealthContent.vue?vue&type=script&lang=js"
export * from "./TargetCampaignHealthContent.vue?vue&type=script&lang=js"
import style0 from "./TargetCampaignHealthContent.vue?vue&type=style&index=0&id=274cdd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274cdd38",
  null
  
)

export default component.exports